/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './NavSponsorBranding.style';
import messages from 'src/shared/app/nav/l10n/navigationL10n';

import SponsorList from '@e180/ui/lib/component/Sponsor/List';

import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';

import type { Picture } from '@e180/domain/lib/base/type';

type Props = {
  sponsors: [
    {
      name: ?string,
      logo: ?Picture,
      url: ?string,
    },
  ],
  tagline: ?string,
};

const useStyles = createUseStyles(styles);

const NavSponsorBrandingDumb = ({ sponsors, tagline }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |------------------------------------------------------------------------------
   | Event Handlers
   |------------------------------------------------------------------------------
   */

  const handleClick = (event) => {
    const name = event.target.value;
    return trackGAEvent('Navigation', 'Click sponsor logo', name);
  };

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <SponsorList
        sponsors={sponsors}
        tagline={tagline || intl.formatMessage(messages.presented)}
        taglinePosition="top"
        onClick={handleClick}
        isVertical
        isDark
      />
    </div>
  );
};

export default compose(React.memo)(NavSponsorBrandingDumb);
